/**
 * Kundenübergreifende Vertragsänderungen (Fall Fortis Unum, WKR 0118).
 *
 * Eine neue Position ohne System und eine weggefallene mit noch aktivem
 * System tauchten nirgendwo auf; unzugeordnete Verträge bleiben sonst
 * unsichtbar. Seite und Sidebar-Badge teilen denselben Query-Cache.
 * Der Sync läuft alle 6 Stunden, öfter pollen bringt nichts.
 */

import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { queryKeys } from '@/lib/query';
import type { ContractChanges } from '@/types/contractReconciliation';

export function useContractChanges(): ReturnType<typeof useQuery<ContractChanges>> {
  return useQuery<ContractChanges>({
    queryKey: queryKeys.contracts.changes,
    queryFn: () => api.get<ContractChanges>('/contracts/changes'),
    staleTime: 60_000,
  });
}

/** Zahl für das Sidebar-Badge. 0 heißt: nichts anzeigen. */
export function useContractChangesCount(): number {
  const { data } = useContractChanges();
  return data?.open_total ?? 0;
}
